import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';

/* MODAL */
import { useModal } from 'hooks/modalContext';

/* 공통 JS */
import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';

/* Full Calendar */
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import 'assets/css/calendar.css';

/* DatePicker */
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

export default function Dispatch() {
  const { openModal } = useModal();

  const calendarRef = useRef(null);

  const initialStartDate = new Date();

  const [search, setSearch] = useState({
    fkCustMstSeq: 0,
    workDay: moment(initialStartDate).format('YYYY-MM'),
    date: new Date(initialStartDate.setHours(0, 0, 0, 0))
  });
  const [custMstList, setCustMstList] = useState([{
    custMstSeq: 0,
    custName: '',
  }]);
  const [schedule, setSchedule] = useState([]);

  useEffect(() => {
    Common.isLogin();

    getCustMstList();
  }, []);

  const getCustMstList = () => {
    Server.sendGet('client/select/all', {}, getCustMstListCallback).then();
  };

  const getCustMstListCallback = res => {
    setSearch(() => {
      return {
        ...search,
        fkCustMstSeq: res?.['resultList']?.[0]?.custMstSeq,
      }
    });
    setCustMstList(res?.['resultList']);

    Server.sendGet('client/schedule', {
      fkCustMstSeq: res?.['resultList']?.[0]?.custMstSeq,
      workDay: search?.workDay
    }, getCustScheduleMstListCallback).then();
  };

  const handleDateClick = (date) => {
    openModal({
      modalName: 'ClientDispatchModal',
      modalData: {
        isRegi: true,
        data: {
          item: {
            fkCustMstSeq: search?.fkCustMstSeq,
            date: date.dateStr,
          },
          callback: getCustScheduleMstList,
        },
      }
    });
  };

  const handleEventClick = (e) => {
    openModal({
      modalName: 'ClientDispatchModal',
      modalData: {
        isRegi: true,
        data: {
          item: {
            fkCustMstSeq: e.event._def.extendedProps.fkCustMstSeq,
            date: e.event._def.extendedProps.workDay,
            fkCustScheduleMstSeq: e.event._def.extendedProps.custScheduleMstSeq,
          },
          callback: getCustScheduleMstList,
        },
      }
    });
  };

  const handleStartDateChange = (date) => {
    setSearch(() => {
      return {
        ...search,
        date: date,
        workDay: moment(date).format('YYYY-MM'),
      }
    });
  };

  const onSearch = () => {
    const calendarApi = calendarRef.current.getApi();

    calendarApi.gotoDate(search?.date);

    getCustScheduleMstList();
  };

  const getCustScheduleMstList = () => {
    Server.sendGet('client/schedule', search, getCustScheduleMstListCallback).then();
  };

  const getCustScheduleMstListCallback = res => {
    res['resultList'].forEach(v => {
      v.start = v['inTime'];
      v.end = v['endTime'];
    });

    setSchedule(res['resultList']);
  };

  return (
    <>
      <Inner>
        <Title>
          <TitHead>
            <i/>
            <h4>Client dispatch schedule management</h4>
          </TitHead>
        </Title>
        <SearchArea>
          <CateIn>
            <Cate>
              <CateSel
                name='workForm'
                id='workForm'
                value={search?.fkCustMstSeq}
                onChange={e => {
                  setSearch(() => {
                    return {
                      ...search,
                      fkCustMstSeq: e.target.value,
                    };
                  });
                }}
              >
                {custMstList?.map(item => (
                  <option key={item.custMstSeq} value={item.custMstSeq}>{item.custName}</option>
                ))}
              </CateSel>
            </Cate>
          </CateIn>
          <DateIn>
            <DatePicker
              selected={search?.date}
              onChange={handleStartDateChange}
              dateFormat='yyyy-MM'
              placeholderText='Start Date'
              showMonthYearPicker
            />
          </DateIn>
          <SearchBtn onClick={onSearch}>Search</SearchBtn>
        </SearchArea>
        <Content>
          <FullCalendar
            ref={calendarRef}
            plugins={[dayGridPlugin, interactionPlugin]}
            headerToolbar={{
              right: '',
              center: 'title',
              left: ''
            }}
            editable={false}
            dayMaxEvents={true}
            events={schedule}
            dateClick={handleDateClick}
            eventClick={handleEventClick}
          />
        </Content>
      </Inner>
    </>
  )
}

const Inner = styled.div`
  flex: 1;
  background: #ffffff;
`;

const Title = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
`;

const TitHead = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & i {
    display: block;
    width: 4px;
    height: 32px;
    border-radius: 0 2px 2px 0;
    background: #1e1e1e;
  }

  & h4 {
    font-weight: 500;
    font-size: 16px;
    color: #000000;
  }
`;

const SearchArea = styled.div`
  position: relative;
  margin-top: 35px;
  padding: 15px 20px;
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  align-items: center;
  gap: 0 15px;
  width: 100%;

  & .react-datepicker__tab-loop {
    position: absolute;
  }
`;

const DateIn = styled.div`
  display: flex;
  align-items: center;
  gap: 0 15px;

  & input {
    width: 160px;
    height: 40px;
    line-height: 40px;
    padding: 0 16px;
    font-weight: 400;
    font-size: 16px;
    color: #777777;
    background: #f8f8f8 url('https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/date_ic.svg') top 50% right 10px no-repeat;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 5px;
    outline: none;
  }

  & i {
    display: block;
    width: 12px;
    height: 1px;
    background: rgba(0, 0, 0, 0.12);
  }

  & .react-datepicker-popper {
    width: 226px;
    z-index: 99;
  }
`;

const CateIn = styled.div`
  display: flex;
  align-items: center;
  gap: 0 20px;
`;

const Cate = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & label {
    font-weight: 400;
    font-size: 16px;
    color: #777777;
  }
`;

const CateSel = styled.select`
  width: 200px;
  height: 40px;
  line-height: 40px;
  padding: 0 16px;
  font-weight: 400;
  font-size: 16px;
  color: #777777;
  background: #f8f8f8 url('https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/sel_arrow.svg') top 50% right 10px no-repeat;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  outline: none;
`;

const SearchBtn = styled.button`
  width: 120px;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  background: #a4a4a4;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;

  &:hover {
    background-color: #7e7e7e;
  }
`;

const Content = styled.div`
  margin-top: 35px;
  position: relative;
  height: 622px;
`;